/* SAM cart drawer v14 */
(function () {
  var cfg = window.SAMCart || {};
  var R = cfg.routes || {};
  var root, overlay, headEl, trustEl, bodyEl, footEl, linesEl, recsEl, recsList, totalEl, saveEl, saveAmt;
  var lastFocus = null;
  var busy = false;
  var internalOps = 0;
  var openTimer = null;
  var lastAdd = 0;

  function $(s) { return root.querySelector(s); }

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  function show(el, on, display) {
    if (!el) { return; }
    el.hidden = !on;
    el.style.setProperty("display", on ? (display || "block") : "none", "important");
  }

  function group(intStr, sep) {
    var out = "", c = 0;
    for (var i = intStr.length - 1; i >= 0; i--) {
      out = intStr.charAt(i) + out;
      c++;
      if (c % 3 === 0 && i > 0) { out = sep + out; }
    }
    return out;
  }

  function money(cents) {
    var f = cfg.money_format || "&euro;{{amount_with_comma_separator}}";
    var v = (Number(cents) / 100).toFixed(2).split(".");
    var i = v[0], d = v[1];
    var out = f;
    out = out.split("{{amount_no_decimals_with_comma_separator}}").join(group(i, "."));
    out = out.split("{{amount_with_comma_separator}}").join(group(i, ".") + "," + d);
    out = out.split("{{amount_no_decimals}}").join(group(i, ","));
    out = out.split("{{amount}}").join(group(i, ",") + "." + d);
    return out;
  }

  function skeleton() {
    var row = '<div style="display:grid;grid-template-columns:56px 1fr;gap:12px;padding:12px 16px;border-bottom:1px solid #f0f0f0">' +
      '<div style="width:56px;height:56px;border-radius:4px;background:#f0f0f0"></div>' +
      '<div><div style="height:11px;width:75%;background:#f0f0f0;border-radius:3px;margin-bottom:7px"></div>' +
      '<div style="height:11px;width:45%;background:#f4f4f4;border-radius:3px;margin-bottom:11px"></div>' +
      '<div style="height:28px;width:110px;background:#f4f4f4;border-radius:8px"></div></div></div>';
    linesEl.innerHTML = '<div style="opacity:.7">' + row + row + "</div>";
    totalEl.textContent = "";
    show(saveEl, false);
    show(recsEl, false);
  }

  function fit() {
    if (root.parentNode !== document.body) {
      document.body.appendChild(overlay);
      document.body.appendChild(root);
    }
    var h = window.innerHeight;
    root.style.setProperty("position", "fixed", "important");
    root.style.setProperty("top", "0px", "important");
    root.style.setProperty("bottom", "auto", "important");
    root.style.setProperty("height", h + "px", "important");
    root.style.setProperty("max-height", h + "px", "important");
    overlay.style.setProperty("position", "fixed", "important");
    overlay.style.setProperty("top", "0px", "important");
    overlay.style.setProperty("left", "0px", "important");
    overlay.style.setProperty("width", "100%", "important");
    overlay.style.setProperty("height", h + "px", "important");
    layout();
  }

  function layout() {
    var h = window.innerHeight;
    var used = (headEl ? headEl.offsetHeight : 0) + (footEl ? footEl.offsetHeight : 0);
    var avail = Math.max(120, h - used);
    bodyEl.style.setProperty("height", avail + "px", "important");
    bodyEl.style.setProperty("max-height", avail + "px", "important");
    bodyEl.style.setProperty("overflow-y", "auto", "important");
  }

  function setBusy(s) { busy = s; root.classList.toggle("is-busy", s); }
  function isOpen() { return root.getAttribute("aria-hidden") === "false"; }

  function showDrawer() {
    fit();
    if (isOpen()) { return; }
    lastFocus = document.activeElement;
    overlay.hidden = false;
    overlay.style.setProperty("display", "block", "important");
    root.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("sam-cart-open");
    requestAnimationFrame(function () {
      overlay.classList.add("is-open");
      root.classList.add("is-open");
      layout();
    });
    root.focus();
  }

  function openFresh() {
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    if (!isOpen()) { skeleton(); showDrawer(); }
    return getCart().then(render).catch(function () {});
  }

  function close() {
    root.classList.remove("is-open");
    overlay.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("sam-cart-open");
    setTimeout(function () {
      overlay.hidden = true;
      overlay.style.setProperty("display", "none", "important");
    }, 280);
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function api(url, opts) {
    internalOps++;
    return fetch(url, opts).then(function (r) { internalOps--; return r; },
                                 function (e) { internalOps--; throw e; });
  }

  function getCart() {
    return api(R.cart_js || "/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function readError(r) {
    return r.json().then(function (e) { throw new Error(e.description || e.message || ""); },
                         function () { throw new Error(""); });
  }

  function changeLine(key, qty) {
    if (busy) { return; }
    setBusy(true);
    api(R.change_js || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.ok ? r.json() : readError(r); })
      .then(render)
      .catch(function (err) { alert((err && err.message) ? err.message : cfg.text.error); refresh(); })
      .then(function () { setBusy(false); });
  }

  function addVariant(id, btn) {
    if (busy) { return; }
    setBusy(true);
    if (btn) { btn.disabled = true; }
    api(R.add_js || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.ok ? getCart() : readError(r); })
      .then(render)
      .catch(function (err) { alert((err && err.message) ? err.message : cfg.text.error); })
      .then(function () { setBusy(false); if (btn) { btn.disabled = false; } });
  }

  function submitAddForm(form) {
    var now = Date.now();
    if (busy || (now - lastAdd) < 600) { return; }
    lastAdd = now;
    setBusy(true);
    skeleton();
    showDrawer();
    api(R.add_js || "/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      headers: { "Accept": "application/json" }
    }).then(function (r) { return r.ok ? getCart() : readError(r); })
      .then(render)
      .catch(function (err) {
        refresh();
        alert((err && err.message) ? err.message : cfg.text.error);
      })
      .then(function () { setBusy(false); });
  }

  function addForm(el) {
    if (!el || !el.closest) { return null; }
    var form = el.closest('form[action*="/cart/add"]');
    if (form) { return form; }
    if (el.form && el.form.action && el.form.action.indexOf("/cart/add") !== -1) { return el.form; }
    return null;
  }

  function showVariant(item) {
    var t = item.variant_title;
    if (!t || t === "Default Title" || t === item.product_title) { return false; }
    return true;
  }

  function render(cart) {
    var btn = $(".sam-cart__checkout");
    if (!cart || !cart.items || cart.items.length === 0) {
      linesEl.innerHTML = '<p class="sam-cart__empty">' + esc(cfg.text.empty) + "</p>";
      totalEl.textContent = money(0);
      btn.disabled = true;
      show(recsEl, false);
      saveAmt.textContent = "";
      show(saveEl, false);
      syncTheme(0);
      layout();
      return;
    }
    btn.disabled = false;

    var qtyLabel = esc(cfg.text.qty || "Aantal");
    var html = "";
    cart.items.forEach(function (item) {
      var img = item.image ? item.image : "";
      var extra = "";
      var diff = item.original_line_price - item.final_line_price;
      if (diff > 0) {
        extra = '<span class="sam-cart__line-compare">' + money(item.original_line_price) + "</span>" +
                '<span class="sam-cart__line-save">-' + money(diff) + "</span>";
      }
      html += '<div class="sam-cart__line" data-key="' + esc(item.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "<span></span>") +
        "<div>" +
          '<p class="sam-cart__line-title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + "</a></p>" +
          (showVariant(item) ? '<p class="sam-cart__line-variant">' + esc(item.variant_title) + "</p>" : "") +
          '<p class="sam-cart__line-price"><span>' + money(item.final_line_price) + "</span>" + extra + "</p>" +
          '<div class="sam-cart__line-controls">' +
            '<div class="sam-cart__qty">' +
              '<button type="button" data-act="dec" aria-label="-">-</button>' +
              '<input type="text" inputmode="numeric" autocomplete="off" data-qty value="' + item.quantity + '" aria-label="' + qtyLabel + '">' +
              '<button type="button" data-act="inc" aria-label="+">+</button>' +
            "</div>" +
          "</div>" +
        "</div>" +
        '<button type="button" class="sam-cart__remove" data-act="del" aria-label="' + esc(cfg.text.remove) + '">&times;</button>' +
      "</div>";
    });
    linesEl.innerHTML = html;
    totalEl.textContent = money(cart.total_price);

    saveAmt.textContent = "";
    show(saveEl, false);
    var orig = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
    var saved = orig - cart.total_price;
    if (saved > 0) {
      saveAmt.textContent = "-" + money(saved);
      show(saveEl, true, "flex");
    }

    syncTheme(cart.item_count);
    layout();
    loadRecs(cart);
  }

  function syncTheme(count) {
    var n = document.querySelectorAll("[data-sam-cart-count]");
    for (var i = 0; i < n.length; i++) { n[i].textContent = count; }
    try { document.dispatchEvent(new CustomEvent("ajaxCart")); } catch (e) {}
  }

  function loadRecs(cart) {
    var last = cart.items[cart.items.length - 1];
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var limit = cfg.rec_limit || 3;
    var base = R.recommendations || "/recommendations/products";
    var url = base + ".json?product_id=" + last.product_id + "&limit=10&intent=" + (cfg.intent || "related");
    api(url, { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.products || []).filter(function (p) {
          return p.available && inCart.indexOf(p.id) === -1;
        }).slice(0, limit);
        if (!items.length) { show(recsEl, false); layout(); return; }

        var qtyLabel = esc(cfg.text.qty || "Aantal");
        var html = "";
        items.forEach(function (p) {
          var avail = p.variants.filter(function (v) { return v.available; });
          if (!avail.length) { return; }
          var first = avail[0];
          var multi = avail.length > 1;
          var img = p.featured_image ? p.featured_image : "";

          var opts = "";
          if (multi) {
            avail.forEach(function (v) {
              opts += '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + "</option>";
            });
          }

          html += '<div class="sam-cart__rec' + (multi ? " has-variants" : "") + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "<span></span>") +
            "<div>" +
              '<p class="sam-cart__rec-name">' + esc(p.title) + "</p>" +
              '<span class="sam-cart__rec-price" data-rec-price>' + money(first.price) + "</span>" +
            "</div>" +
            '<button type="button" data-add="' + first.id + '">' + esc(cfg.text.add) + "</button>" +
            (multi ? '<select class="sam-cart__rec-select" data-rec-select aria-label="' + qtyLabel + '">' + opts + "</select>" : "") +
          "</div>";
        });
        recsList.innerHTML = html;
        show(recsEl, html !== "");
        layout();
      })
      .catch(function () { show(recsEl, false); layout(); });
  }

  function refresh() { return getCart().then(render).catch(function () {}); }

  function lineQty(line) {
    var input = line.querySelector("[data-qty]");
    var n = parseInt(input.value, 10);
    return isNaN(n) ? 0 : n;
  }

  function commitQty(input) {
    var line = input.closest(".sam-cart__line");
    if (!line) { return; }
    var raw = "";
    for (var i = 0; i < input.value.length; i++) {
      var ch = input.value.charAt(i);
      if (ch >= "0" && ch <= "9") { raw += ch; }
    }
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 0) { refresh(); return; }
    if (n > 9999) { n = 9999; }
    changeLine(line.getAttribute("data-key"), n);
  }

  /* Variantkeuze in een aanbeveling: knop en prijs meelaten lopen. */
  function pickVariant(sel) {
    var rec = sel.closest(".sam-cart__rec");
    if (!rec) { return; }
    var opt = sel.options[sel.selectedIndex];
    if (!opt) { return; }
    var btn = rec.querySelector("[data-add]");
    if (btn) { btn.setAttribute("data-add", opt.value); }
    var pr = rec.querySelector("[data-rec-price]");
    if (pr) { pr.textContent = money(Number(opt.getAttribute("data-price"))); }
  }

  function isCartWrite(u) {
    if (!u) { return false; }
    var s = String(u);
    return s.indexOf("/cart/add") !== -1 || s.indexOf("/cart/change") !== -1 ||
           s.indexOf("/cart/update") !== -1 || s.indexOf("/cart/clear") !== -1;
  }

  function externalChange() {
    if (internalOps > 0) { return; }
    if (openTimer) { clearTimeout(openTimer); }
    openTimer = setTimeout(openFresh, 80);
  }

  function hookNetwork() {
    var of = window.fetch;
    if (of) {
      window.fetch = function () {
        var url = arguments[0];
        if (url && url.url) { url = url.url; }
        var wasInternal = internalOps > 0;
        var p = of.apply(this, arguments);
        if (isCartWrite(url) && !wasInternal) { p.then(externalChange).catch(function () {}); }
        return p;
      };
    }
    var ox = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (m, u) {
      this.addEventListener("load", function () {
        if (isCartWrite(u)) { externalChange(); }
      });
      return ox.apply(this, arguments);
    };
  }

  function init() {
    root = document.getElementById("sam-cart");
    overlay = document.getElementById("sam-cart-overlay");
    if (!root || !overlay) { return; }
    headEl = $(".sam-cart__head");
    trustEl = $(".sam-cart__trust");
    bodyEl = $(".sam-cart__body");
    footEl = $(".sam-cart__foot");
    linesEl = $(".sam-cart__lines");
    recsEl = $(".sam-cart__recs");
    recsList = $(".sam-cart__recs-list");
    totalEl = $(".sam-cart__total");
    saveEl = $(".sam-cart__savings");
    saveAmt = $(".sam-cart__savings-amount");

    show(saveEl, false);
    show(recsEl, false);

    fit();
    window.addEventListener("resize", fit);
    window.addEventListener("orientationchange", fit);
    if (window.ResizeObserver) {
      new ResizeObserver(layout).observe(footEl);
      if (trustEl) { new ResizeObserver(layout).observe(trustEl); }
    }
    setTimeout(layout, 1500);
    setTimeout(layout, 4000);

    overlay.addEventListener("click", close);
    $(".sam-cart__close").addEventListener("click", close);
    $(".sam-cart__checkout").addEventListener("click", function () {
      window.location.href = R.checkout || "/checkout";
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) { close(); }
    });

    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") { return; }
      var input = e.target.closest("[data-qty]");
      if (!input) { return; }
      e.preventDefault();
      input.blur();
    });
    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-rec-select]");
      if (sel) { pickVariant(sel); return; }
      var input = e.target.closest("[data-qty]");
      if (input) { commitQty(input); }
    });
    root.addEventListener("focusout", function (e) {
      var input = e.target.closest("[data-qty]");
      if (input) { commitQty(input); }
    });
    root.addEventListener("focusin", function (e) {
      var input = e.target.closest("[data-qty]");
      if (input) { input.select(); }
    });

    root.addEventListener("click", function (e) {
      var addBtn = e.target.closest("[data-add]");
      if (addBtn) { addVariant(Number(addBtn.getAttribute("data-add")), addBtn); return; }
      var act = e.target.closest("[data-act]");
      if (!act) { return; }
      var line = act.closest(".sam-cart__line");
      if (!line) { return; }
      var key = line.getAttribute("data-key");
      var qty = lineQty(line);
      var a = act.getAttribute("data-act");
      if (a === "inc") { changeLine(key, qty + 1); }
      if (a === "dec") { changeLine(key, Math.max(0, qty - 1)); }
      if (a === "del") { changeLine(key, 0); }
    });

    document.addEventListener("click", function (e) {
      if (root.contains(e.target)) { return; }
      var btn = e.target.closest('button, input[type="submit"], [type="submit"]');
      if (!btn) { return; }
      var form = addForm(btn);
      if (!form) { return; }
      if (typeof window.SAMCartIsAddButton === "function") {
        if (!window.SAMCartIsAddButton(btn, form)) { return; }
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      submitAddForm(form);
    }, true);

    document.addEventListener("click", function (e) {
      var a = e.target.closest("a");
      if (!a) { return; }
      var href = a.getAttribute("href") || "";
      if (href === "/cart" || href.endsWith("/cart")) { e.preventDefault(); openFresh(); }
    });

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf("/cart/add") === -1) { return; }
      e.preventDefault();
      submitAddForm(form);
    }, true);

    hookNetwork();
    refresh();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();